import { Box, ListItemIcon, Typography } from "@mui/material";
import { ReactComponent as AlertNotiIcon } from "assets/svg/noti-alert.svg";
import React from "react";
import { useNotificationLocalStorage } from "hooks/useNotificationLocalStorage";
import { SensorAlertNotification } from "../types";
import {
    ContentBox,
    NotificationHeader,
    SensorInfoBox,
    StyledListItem,
} from "./shared";
import SensorIcon from "components/gateways/SensorIcon";
import { APP_CONFIG } from "config/appConfig";

interface SensorAlertsItemProps {
    notification: SensorAlertNotification;
    organizationsMap: Map<string, string>;
}

export const SensorAlert = ({
    notification,
    organizationsMap,
}: SensorAlertsItemProps) => {
    const { isNotificationRead } = useNotificationLocalStorage();
    const isOnPrem = APP_CONFIG.APP_IS_ONPREM;
    const gatewayLabel = isOnPrem ? "Network:" : "Gateway:";
    const ldsuLabel = isOnPrem ? "Auxiliary Hub:" : "LDSU:";
    return (
        <StyledListItem
            alignItems="flex-start"
            className={isNotificationRead(notification.id) ? "read" : "unread"}
        >
            <ListItemIcon>
                <AlertNotiIcon />
            </ListItemIcon>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    width: "100%",
                }}
            >
                <NotificationHeader
                    title={notification.title}
                    orgName={
                        organizationsMap.get(notification.orgId) ||
                        notification.orgId
                    }
                    timestamp={notification.time}
                    type="Sensor Alert"
                />

                <ContentBox>
                    <SensorInfoBox>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 1.5,
                                alignItems: "center",
                            }}
                        >
                            <SensorIcon
                                sensorType={notification.info.sensorType}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Typography variant="body2">
                                    {notification.info.sensorName}
                                </Typography>
                                <Typography variant="caption" color="#828fab">
                                    {notification.info.sensorType}
                                </Typography>
                            </Box>
                        </Box>
                        {notification.info.alertValue && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 0.5,
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="body2" color="#828fab">
                                    Alert Value:
                                </Typography>
                                <Typography variant="body2" color="#00CBAF">
                                    {notification.info.alertValue}
                                </Typography>
                            </Box>
                        )}
                    </SensorInfoBox>

                    <Box
                        sx={{
                            marginTop: "10px",
                            gap: 0.5,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Typography variant="caption" color="#828fab">
                            {notification.info.alertMessage}
                        </Typography>

                        <Typography variant="caption">
                            Condition:{" "}
                            <span style={{ color: "#828fab" }}>
                                {notification.info.condition}
                            </span>
                        </Typography>
                        <Typography variant="caption">
                            {gatewayLabel}{" "}
                            <span style={{ color: "#828fab" }}>
                                {notification.info.gatewayName}
                            </span>
                        </Typography>
                        <Typography variant="caption">
                            {ldsuLabel}{" "}
                            <span style={{ color: "#828fab" }}>
                                {notification.info.ldsuName}
                            </span>
                        </Typography>
                    </Box>
                </ContentBox>
            </Box>
        </StyledListItem>
    );
};
